//import _ from 'lodash'
import { ActionTypes } from '../actions'

const {
  FETCH_INITIAL_DATA_REQUEST,
  FETCH_INITIAL_DATA_RECEIVED,
} = ActionTypes

const misc = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INITIAL_DATA_REQUEST:
      return {
        ...state,
        dataIsLoading: true,
        dataIsRequested: true,
      }
    case FETCH_INITIAL_DATA_RECEIVED:
      return {
        ...state,
        dataIsLoading: false,
        ...action.data.misc,
      }
    default:
      return state
  }
}

export default misc
